import {requestDeadline} from '../utils/requestDeadline'
import { supabase } from '../lib/supabase'
import type { BlissRoomPlanPayload, BlissRoomPlanRecord } from '../config/blissRoomPlan'

export async function fetchBlissRoomPlan(planId: string): Promise<BlissRoomPlanRecord | null> {
  if (!planId.trim()) return null
  try {
    return await requestDeadline(async signal=>{
    const {data} = await supabase.auth.getSession()
    signal.throwIfAborted()
    const res = await fetch(`/api/bliss-room-plan?id=${encodeURIComponent(planId.trim())}`,{signal,headers:data.session?{Authorization:`Bearer ${data.session.access_token}`}:{}})
    if (res.status === 404) return null
    if (!res.ok) return null
    const json = (await res.json()) as { plan: BlissRoomPlanRecord }
    return json.plan ?? null
    })
  } catch {
    return null
  }
}

export async function saveBlissRoomPlan(
  payload: BlissRoomPlanPayload,
  existingId?: string | null,
): Promise<{ plan: BlissRoomPlanRecord | null; error?: string }> {
  try {
    return await requestDeadline(async signal=>{
    const {data} = await supabase.auth.getSession()
    signal.throwIfAborted()
    const res = await fetch('/api/bliss-room-plan', {
      signal,
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...(data.session?{Authorization:`Bearer ${data.session.access_token}`}:{}) },
      body: JSON.stringify(existingId ? { ...payload, id: existingId } : payload),
    })
    const json = (await res.json()) as { plan?: BlissRoomPlanRecord; error?: string }
    if (!res.ok) {
      return { plan: null, error: json.error || 'Could not save plan' }
    }
    return { plan: json.plan ?? null }
    })
  } catch {
    return { plan: null, error: 'Network error while saving plan' }
  }
}

